import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, IconButton, Typography, useTheme } from '@mui/material';
import { IconProps, X } from '@phosphor-icons/react';

import { FamilyMemberForm } from '../components/FamilyMemberForm';
import { mapDependentsModel } from 'theSource/features/FamilyMembers/utils';
import { ViewFamilyMemberDrawerStyled } from './ViewFamilyMemberDrawerStyled';
import {
  ButtonLinkStyled,
  DependentPictureStyled,
  FamilyDrawerStyled,
  FirstDrawerDividerMargin,
} from '../FamilyDetailsPageStyled';
import { Button, InternalPage } from 'theSource/components';
import { displayDependentAvatar } from '../components';

export interface ViewFamilyMemberDrawerProps {
  data?: any;
  dependentsData?: any;
  dependentId?: any;
}

export const ViewFamilyMemberDrawer = ({
  data,
  dependentsData,
  dependentId,
}: ViewFamilyMemberDrawerProps) => {
  const { t } = useTranslation('pages.enrollmentFamily');

  const [openViewFamilyDetailsDrawer, setOpenViewFamilyDetailsDrawer] =
    useState<boolean>(false);

  const handleCloseFamilyDrawer = () => {
    setOpenViewFamilyDetailsDrawer(false);
  };

  const theme = useTheme();

  const iconProps: IconProps = {
    size: 18,
    color: theme.palette.primary.main,
    weight: 'bold',
  };

  const categories = useMemo(
    () => data && mapDependentsModel(dependentsData, data),
    [data, dependentsData]
  );

  return (
    <ViewFamilyMemberDrawerStyled>
      <ButtonLinkStyled>
        <Button
          id="view-details-dependent-btn"
          variant="tertiary"
          label={t('viewDetailsTitle')}
          onClick={() => setOpenViewFamilyDetailsDrawer(true)}
          data-testid="enrollment-view-details-btn"
        />
      </ButtonLinkStyled>
      <FamilyDrawerStyled
        data-testid="viewFamilyDetailsDrawer"
        anchor="right"
        open={openViewFamilyDetailsDrawer}
        onClose={handleCloseFamilyDrawer}
      >
        <IconButton
          sx={{ alignSelf: 'flex-start', mb: '2rem' }}
          data-testid="drawer-close-btn"
          onClick={handleCloseFamilyDrawer}
          aria-haspopup="true"
          aria-expanded="true"
        >
          <X {...iconProps} />
          <Typography variant="button" display="block">
            {t('closeButtonLabel')}
          </Typography>
        </IconButton>
        <InternalPage
          testId="view-family-details"
          title={t('viewDetailsDrawerTitle')}
        >
          <h2 className="headline-3 text-center mt-3">
            {t('viewDetailsDrawerPictureTitle')}
          </h2>
          <DependentPictureStyled>
            {' '}
            {displayDependentAvatar(data?.dependent_profile)}
          </DependentPictureStyled>
        </InternalPage>
        <FirstDrawerDividerMargin orientation="horizontal" />{' '}
        <FamilyMemberForm
          dependentId={dependentId}
          categories={categories}
          values={data}
        />
        <Grid container justifyContent="right">
          <Grid item>
            <ps-button
              id="view-details-cancel-btn"
              level="tertiary"
              label={t('cancelButtonLabel')}
              onClick={handleCloseFamilyDrawer}
            />
          </Grid>
        </Grid>
      </FamilyDrawerStyled>
    </ViewFamilyMemberDrawerStyled>
  );
};
